import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cit-footer',
  templateUrl: './cit-footer.component.html',
  styles: ['']
})
export class CitFooterComponent implements OnInit {
  myDate = new Date();
  constructor() { }

  ngOnInit() {
  }



}
